// Unauthorized - Software Approval Request
import createReducer from './../lib/createReducer';
import * as types from './../actions/types';

export const softwareRequest = createReducer({},
  {
    [types.GET_BOOKING_SOFTWARE_REQUEST_START]() {
      const newState = {};

      return newState;
    },

    [types.GET_BOOKING_SOFTWARE_REQUEST_SUCCESS](state, action) {
      const newState = Object.assign({}, state, action.software);

      return newState;
    },

    [types.GET_BOOKING_SOFTWARE_REQUEST_FAIL]() {
      const newState = {};

      return newState;
    },
  },
);

export { softwareRequest as default };
